import { render, staticRenderFns } from "./r-bundle-christmas-panel.vue?vue&type=template&id=fda56402"
import script from "./r-bundle-christmas-panel.vue?vue&type=script&lang=js"
export * from "./r-bundle-christmas-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fda56402')) {
      api.createRecord('fda56402', component.options)
    } else {
      api.reload('fda56402', component.options)
    }
    module.hot.accept("./r-bundle-christmas-panel.vue?vue&type=template&id=fda56402", function () {
      api.rerender('fda56402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-christmas/r-bundle-christmas-panel.vue"
export default component.exports